import { ReactRenderer } from "@tiptap/react";
import { SuggestionOptions } from "@tiptap/suggestion";
import tippy, { Tippy } from "tippy.js";
import { UserInfoProjectorImpl } from "types/api/userInfoProjectorImpl";

import MentionList from "./MentionList";

export const mentionSuggestion = ({
  users,
}: {
  users: UserInfoProjectorImpl[];
}): Partial<SuggestionOptions> => ({
  allowSpaces: true,
  items: ({ query }: { query: string }) => {
    const startsWith: UserInfoProjectorImpl[] = [],
      contains: UserInfoProjectorImpl[] = [];
    users.forEach((item) => {
      const name = item.displayName!.toLowerCase(),
        _query = query.toLowerCase();
      if (name.startsWith(_query)) {
        startsWith.push(item);
      } else if (name.includes(_query)) {
        contains.push(item);
      }
    });
    return startsWith.concat(contains);
  },

  render: () => {
    let component: ReactRenderer;
    let popup: Tippy<unknown>;
    let isEditorEditable = false;

    return {
      onStart: (props) => {
        // Track editable state for use in onKeyDown (which doesn't have editor in props)
        isEditorEditable = props.editor.isEditable;

        // Don't show suggestion popup if editor is not editable (read-only/disabled mode)
        if (!isEditorEditable) {
          return;
        }

        component = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        // @ts-expect-error TODO fix tippy types
        popup = tippy(".app-content-wrapper", {
          getReferenceClientRect: props.clientRect,
          appendTo: () =>
            document.getElementsByClassName("app-content-wrapper")[0] ||
            document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: "manual",
          placement: "bottom-start",
        });
      },

      onUpdate(props) {
        // Don't update if editor is not editable
        if (!props.editor.isEditable) {
          return;
        }

        component?.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        // @ts-expect-error TODO fix types
        popup?.[0].setProps({
          getReferenceClientRect: props.clientRect,
        });
      },

      onKeyDown(props) {
        // Don't handle keyboard if editor is not editable
        if (!isEditorEditable) {
          return false;
        }

        if (props.event.key === "Escape") {
          // @ts-expect-error TODO fix types
          popup?.[0]?.hide();

          return true;
        }

        // @ts-expect-error TODO fix types
        return component?.ref?.onKeyDown(props);
      },

      onExit() {
        // @ts-expect-error TODO fix types
        popup?.[0]?.destroy();
        component?.destroy();
      },
    };
  },
});
